module.exports = __webpack_public_path__ + "shanz/static/media/footerLogo.d49c511b.png";